import styled from 'styled-components';
import { colors, medias } from 'assets/styled/tokens';

export const StyledSubCategory = styled.ul`
  background-color: ${colors.pampas};
  position: absolute;
  height: 100vh;
  visibility: visible;
  background-color: white;
  width: 50vw;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  left: 0;
  transform: translateX(-100%);
  top: -96px;
  padding-top: 24px;
  transition: all 0.3s ease-in-out;
  box-shadow: inset rgba(0, 0, 0, 0.15) 0px 1px 8px 0px;
  z-index: -1;

  @media (max-width: ${medias.tablet}) {
    width: 60vw;
  }
`;
export const StyledSubCategoryTitle = styled.h2`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  color: #1e1e1e;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
`;
export const CloseActionsContainer = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const CloseArrow = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 100%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;

export const CloseMenu = styled.div`
  border-radius: 100%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;
export const SubcategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  align-items: flex-start;
`;

export const SubcategoryItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 10px;

  width: 100%;
  & > div a {
    margin: 0;
    padding: 5px;
    text-align: left;
    flex-direction: row !important;
    justify-content: flex-start;
  }
`;
